import { CLIENTS } from "/src/constants/config";

export const getclientBodyClass = (client) => {
  switch (client) {
    case CLIENTS.ADLER: {
      return "app-adler";
      break;
    }
    default: {
      return "app-opta";
    }
  }
};
